import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber, injectIntl, intlShape } from 'react-intl';
import { Field } from 'redux-form';
import { get } from 'lodash';
import SelectField from '../../fields/SelectField/SelectField';
import AddOnField from '../../fields/AddOnField/AddOnField';
import NumberField from '../../fields/NumberField/NumberField';
import EllipsisDropdown from '../../../../../elements-dropdown/EllipsisDropdown';

class AddOnsRow extends Component {
  constructor (props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleClickDelete = this.handleClickDelete.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleViewAddOnClick = this.handleViewAddOnClick.bind(this);
  }

  handleChange (e, val) {
    const { handleItemChange, index } = this.props;
    handleItemChange(val, index);
  }

  handleClickDelete () {
    const { index, itemSelected, getInventoryItem, deleteAddOn } = this.props;

    // this allows us to delete row before quantity is entered
    if (itemSelected) { getInventoryItem(itemSelected.title); }
    deleteAddOn(index);
  }

  handleEditClick () {
    const { index, itemSelected, getInventoryItem, editAddOnAction } = this.props;

    getInventoryItem(itemSelected.title);
    editAddOnAction(index);
  }

  handleViewAddOnClick () {
    const { itemSelected, getInventoryItem, viewAddOnDetailsAction } = this.props;

    getInventoryItem(itemSelected.title);
    viewAddOnDetailsAction(itemSelected._id);
  }

  render () {
    const {
      ssoId,
      item,
      options,
      currency,
      unitCostBasis,
      itemContract = {},
      allOptions = []
    } = this.props;

    const amount = get(itemContract, 'primary_amount', {});
    const addOnAmount = (0 === amount[ssoId] || amount[ssoId]) ? amount[ssoId].toFixed(2) : null;

    let listItems;
    if (addOnAmount) {
      listItems = [
        {
          title: this.props.intl.formatMessage({ id: 'inbox.add_ons_row.details', defaultMessage: 'View details' }),
          onClick: this.handleViewAddOnClick,
          testingId: 'view-option'
        },
        {
          title: this.props.intl.formatMessage({ id: 'inbox.add_ons_row.edit', defaultMessage: 'Edit add on' }),
          onClick: this.handleEditClick,
          testingId: 'edit-option'
        },
        {
          title: this.props.intl.formatMessage({ id: 'inbox.add_ons_row.delete', defaultMessage: 'Delete' }),
          onClick: this.handleClickDelete,
          className: 'option-delete',
          testingId: 'delete-option'
        }
      ];
    } else {
      listItems = [
        {
          title: this.props.intl.formatMessage({ id: 'inbox.add_ons_row.delete_else', defaultMessage: 'Delete' }),
          onClick: this.handleClickDelete,
          className: 'option-delete',
          testingId: 'delete-option'
        }
      ];
    }

    return (
      <div className="AddOnsRow add-on-row space-between d-xs-none d-sm-flex" key={item}>
        <div className="title-field">
          <Field
            name={`${item}.title`}
            className="row-item"
            component={SelectField}
            placeholder={ this.props.intl.formatMessage({ id: 'inbox.add_ons_row.select_item', defaultMessage: 'Please select an item' }) }
            options={options}
            allOptions={allOptions}
            maxMenuHeight={160}
            id="add-on-field"
            onChange={this.handleChange}
            errorMessage={ this.props.intl.formatMessage({ id: 'inbox.add_ons_row.select_item_error', defaultMessage: 'Please select an item' }) }
          />
        </div>

        <div className="quantity-field">
          <Field
            name={`${item}.count`}
            className="row-item"
            component={NumberField}
            attributes={{ 'data-testing-id': 'count-field' }}
          />
        </div>

        <div className="price-field flex space-between">
          <div className="unit-cost-field margin-md-right">
            <Field
              name={`${item}.unit_cost`}
              className="row-item"
              label={currency}
              isCurrency
              component={AddOnField}
              fieldType="number"
              leftLabel
              attributes={{ 'data-testing-id': 'unit-cost-field' }}
            />
          </div>
          <div className="rate" data-testing-id="unit-cost-basis">{unitCostBasis}</div>
        </div>

        <div className="amount-field">
          <div className="row-item" />
          <div className="flex middle space-between" style={{ height: '100%' }}>
            <span className="cost" data-tesing-id="cost">
              <FormattedNumber value={addOnAmount || '0.00'} currency={currency} style={'currency'} />
            </span>
            <EllipsisDropdown
              listItems={listItems}
              attributes={{ 'data-testing-id': 'ellipses-menu' }}
            />
          </div>
        </div>
      </div>
    );
  }
}

AddOnsRow.propTypes = {
  deleteAddOn: PropTypes.func,
  viewAddOnDetailsAction: PropTypes.func,
  editAddOnAction: PropTypes.func,
  handleItemChange: PropTypes.func,
  getInventoryItem: PropTypes.func,
  ssoId: PropTypes.string,
  item: PropTypes.object,
  itemSelected: PropTypes.object,
  unitCostBasis: PropTypes.string,
  options: PropTypes.array,
  index: PropTypes.number,
  currency: PropTypes.string,
  itemContract: PropTypes.object,
  allOptions: PropTypes.array,
  intl: intlShape
};

export default injectIntl(AddOnsRow);
